import { AbstractControl } from '@angular/forms';

export function RestrictedValidatorFn(ctrl:AbstractControl, restricted:string[]) {
    if (ctrl.value && restricted.includes(ctrl.value)) {
      return {restricted:true};
    }

    return null;
}
